import React, { useEffect, useRef, useState} from "react";
import { connect } from "react-redux";

//store
import * as actions from "../../../../store/actions/actionIndex";

import {
  makeStyles,
  createTheme,
} from "@material-ui/core/styles";
import {
  Search as SearchIcon,
  CancelOutlined,
  CheckCircleOutlined,
  DateRange,
} from "@material-ui/icons";
import {
  Box,
  Button,
  FormControl,
  Select,
  Typography,
  TextField,
  IconButton,
  MenuItem,
  Modal,
  Input,
} from "@material-ui/core";

import LeadBucket from "./LeadBucket";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Calendar } from 'react-date-range';
import { DateRangePicker } from 'react-date-range';


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  listStyle: {
    background: "#ffffff",
    padding: "0 10px",
    width: "90%",
  },
  listItemStyle: {
    border: "1px solid #4e80c5",
    color: "#4e80c5",
    padding: "2px 10px!important",
    textAlign: "center",
    margin: "0 5px",
    "&:hover": {
      background: "#4e80c5",
      color: "#ffffff",
    },
  },
  selected: {
    backgroundColor: "#4e80c5!important",
    color: "#ffffff",
  },
  Button: {
    height: "40px",
    color: "#526FEB",
    textTransform: "capitalize",
    fontSize: "16px",
    "&:hover": {
      backgroundColor: "#526FEB",
      color: "white",
    },
  },
}));

// const theme = createTheme();

const PreviewLeads = (props) => {
  const pickerRef = useRef(null);
  const { agentId, onLeadData, searchParameter, SelectedCN } = props;
  const classes = useStyles();
  const [action, setAction] = useState(true);
  const [open, setOpen] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const searchParameterArray =
    searchParameter === "" ? [] : searchParameter.split(",");
  const [clicked, setClicked] = useState(
    searchParameterArray.map((parameter) => {
      return {
        [parameter]: true,
      };
    })
  );
  const [inputValue, setInputValue] = useState({});
  const [inputType, setInputType] = useState("")
  const [dataRange, setDataRange] = useState("");
  const [selectedRange, setSelectedRange] = useState(() => {
    const date = new Date().toLocaleString('en-US', { timeZone: SelectedCN });
    return {
      startDate: new Date(date),
      endDate: new Date(date),
      key: 'selection'
    };
  });
  
  const changeInputHandler = (value, parameter) => {
    setInputValue({ ...inputValue, [parameter]: value });
  };

  const changeIconehandler = (parameter) => {
    setClicked({ ...clicked, [parameter]: !clicked[parameter] });
    if (clicked[parameter]) {
      delete inputValue[parameter];
    }
  };
  const [dialerType, setDialerType] = React.useState("all");
  const handleChange = (event) => {
    setDialerType(event.target.value);
  };
  const [leadType, setLeadType] = React.useState(5);

  const handleLeadType = (index) => {
    setLeadType(index);
    if (index === 1) {
      const date = new Date().toLocaleString('en-US', { timeZone: SelectedCN });
      const parsedDate = new Date(date);
      const year = parsedDate.getFullYear();
      const month = `0${parsedDate.getMonth() + 1}`.slice(-2);
      const day = `0${parsedDate.getDate()}`.slice(-2);
      const formattedDate = `${year}-${month}-${day}`;
      setDataRange(formattedDate);
    }
    if(index === 2){
      
    }
  };
  
  // const [searchText, setSearchText] = useState("");

useEffect(()=>{
  setInputType(props.viewableHeaders.viewableHeaders_onPreview)
},[inputType,props.viewableHeaders.viewableHeaders_onPreview])

  const handleSearch = () => {
    setAction(false);
    // Call onLeadData with the filtered leads
    onLeadData(agentId, dialerType, leadType, inputValue,inputType, dataRange);
    handleClose();
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    onLeadData(agentId, dialerType, leadType, inputValue,inputType, dataRange);
  }

  useEffect(() => {
    if (action) {
      onLeadData(agentId, dialerType, leadType, "", inputType, dataRange);
    }
  }, [action, agentId, dialerType, inputType, leadType, dataRange]);
  
  const handleSelect = (ranges) => {
    setSelectedRange(ranges.selection);
  };

  const togglePicker = () => setShowPicker(!showPicker);

  const formatDate = (date) => {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
  };
  
  useEffect(() => {
    if (leadType === 2) {
      setDataRange(`${formatDate(selectedRange.startDate)},${formatDate(selectedRange.endDate)}`)

    }
  }, [leadType, selectedRange]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="all-data-fields ">
        <Box
          p={1}
          sx={{
            margin: "0",
            padding: {
              xs: "4px",
              sm: "15px",
            },
            backgroundColor: "#fff",
          }}
        >
          <FormControl  className="forms">
            <Box className="abc"
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}>
              <div className="select-item">
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={dialerType}
                  onChange={handleChange}
                  label="dialer type"
                >
                  <MenuItem value="manual">Manual</MenuItem>
                  <MenuItem value="dialer">Dialer</MenuItem>
                  <MenuItem value="all">Dialer Type</MenuItem>
                </Select>
                <Select
                  labelId="lead-type-label"
                  id="lead-type"
                  value={leadType}
                  onChange={(event) => handleLeadType(event.target.value)}
                  label="Lead Type"
                >
                  <MenuItem value={0}>Fresh Calls</MenuItem>
                  <MenuItem value={1}>Today CallBacks</MenuItem>
                  <MenuItem value={2}>CallBack</MenuItem>
                  <MenuItem value={3}>Finished</MenuItem>
                 {props.enableAbandonCall == "1" && (
                  <MenuItem value={4}>Abandon Call</MenuItem>
                 )}
                  <MenuItem value={5}>Lead Type</MenuItem>
                 
                </Select>
                {leadType === 2 &&(
                 <div style={{ position: 'relative' }}>
                 <Input
                   type="text"
                   className="input-text"
                   value={`${formatDate(selectedRange.startDate)} - ${formatDate(selectedRange.endDate)}`}
                   onClick={togglePicker}
                   readOnly
                   style={{ width: '250px', padding: '5px', cursor: 'pointer' }}
                 />
                 {showPicker && (
                   <div className="date-range" ref={pickerRef} style={{ position: 'absolute', top: 'calc(100% + 5px)', zIndex: 999 }}>
                     <DateRangePicker
                       ranges={[selectedRange]}
                       onChange={handleSelect}
                       moveRangeOnFirstSelection={false}
                     />
                   </div>
                 )}
               </div>
              )}
              </div>
       
            </Box>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className="modal-data">
                <div className="modal-head">
                  <div
                    className="closebutton"
                    style={{
                      display: "inline-block",
                      width: "100%",
                    }}
                  >
                    <CancelOutlined
                      onClick={handleClose}
                      style={{
                        color: "#ddd",
                        marginInlineEnd: "20px",
                        borderRadius: "0 3px 3px 0",
                        fontSize: "30px",
                        float: "right",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                </div>
                <div className="moda-body">
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {searchParameter === "" ? (
                      <div
                        style={{
                          margin: "15px",
                          padding: "20px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Typography>
                          No Search Parameters are configured!
                        </Typography>
                      </div>
                    ) : (
                      <Box
                        component="form"
                        noValidate
                        autoComplete="off"
                        style={{
                          margin: "15px",
                          padding: "20px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <div>
                          {searchParameterArray.map((parameter, index) => {
                            return (
                              <TextField
                                key={index}
                                id={`standard-bare-${parameter}`}
                                variant="outlined"
                                placeholder={parameter}
                                size="small"
                                margin="normal"
                                style={{
                                  marginInlineStart: "15px",
                                  marginInlineEnd: "15px",
                                }}
                                disabled={clicked[parameter] ? false : true}
                                value={
                                  inputValue[parameter]
                                    ? inputValue[parameter]
                                    : ""
                                }
                                onChange={(e) =>
                                  changeInputHandler(e.target.value, parameter)
                                }
                                InputProps={{
                                  endAdornment: (
                                    <IconButton
                                      variant="contained"
                                      className="icons-buttons"
                                      style={{
                                        backgroundColor: clicked[parameter]
                                          ? "#7db317"
                                          : "#ef482c",
                                        padding: "8px",
                                        marginInlineEnd: "-13px",
                                        borderRadius: "0 3px 3px 0",
                                      }}
                                      onClick={() =>
                                        changeIconehandler(parameter)
                                      }
                                    >
                                      {clicked[parameter] ? (
                                        <CheckCircleOutlined
                                          style={{ color: "#7db317" }}
                                        />
                                      ) : (
                                        <CancelOutlined
                                          style={{ color: "#ddd" }}
                                        />
                                      )}
                                    </IconButton>
                                  ),
                                }}
                              />
                            );
                          })}
                        </div>

                        <div className="search-button">
                          <Button
                            className={`${classes.Button} search-btn`}
                            style={{
                              backgroundColor: "#7db317",
                            }}
                            variant="outlined"
                            margin="normal"
                            onClick={() => handleSearch()}
                          >
                            <SearchIcon /> Search
                          </Button>
                        </div>
                      </Box>
                    )}
                  </div>
                </div>
              </Box>
            </Modal>

          </FormControl>
        </Box>
      </div>
      <div className="leadbucket-data">
        {!props.loading && Array.isArray(props.leads) && props.leads.length ? (
          <LeadBucket
            maxHeight="400px"
            leads={props.leads}
            searchAction={handleSearch}
            inputValue = {inputValue}
            handleOpen= {handleOpen}
          />
        ) : (
          <div style={{textAlign:"center"}}>No lead found in the selected fields..</div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.leadData.loading,
    agentId: state.agentData.agentId,
    leads: state.leadData.leads,
    viewableHeaders: state.agentConfig.campConf,
    SelectedCN: state.agentConfig.campConf.agentui_timezone,
    enableAbandonCall: state.agentConfig.facilityConf.enable_abandon_call_in_search,
    searchParameter: state.agentConfig.searchParameter,

  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onLeadData: (agentId, dialerType, leadType,inputValue, inputType, dataRange) => 
      dispatch(actions.leadData(agentId, dialerType, leadType,inputValue,inputType, dataRange)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PreviewLeads);
